// extracted by mini-css-extract-plugin
export default {"JurorVoteCountBanner":"JurorVoteCountBanner_JurorVoteCountBanner__zETgQ","BannerText":"JurorVoteCountBanner_BannerText__mS9NI"};